/* Ellips theme behaviour: header, hero slider, carousels, tabs, accordions, buy box. */

/* Locale-aware helpers shared by every block below. With Markets subfolders the storefront
   lives under /fr/, /nl/ ... so cart and checkout requests, and any root-relative link typed
   into a setting or a page body, must carry that prefix or the shopper drops back to English. */
(function () {
  'use strict';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  window.ellipsUrl = (path) => root + String(path).replace(/^\//, '');

  const sample = window.ellipsMoneySample || '\u20ac1.234,56';
  const m = sample.match(/1(\D?)234(\D)56/);
  const before = m ? sample.slice(0, m.index) : '\u20ac';
  const after = m ? sample.slice(m.index + m[0].length) : '';
  const thousands = m ? m[1] : '.';
  const decimal = m ? m[2] : ',';
  window.ellipsFormatMoney = (cents) => {
    const [whole, fraction] = (Math.round(cents) / 100).toFixed(2).split('.');
    return before + whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + decimal + fraction + after;
  };

  if (root !== '/') {
    const prefix = root.replace(/\/$/, '');
    const skip = /^\/(cdn|checkout|checkouts|apps|services|tools|s\/files)(\/|$)/;
    document.querySelectorAll('a[href^="/"]').forEach((a) => {
      const href = a.getAttribute('href');
      if (href.startsWith('//') || href === prefix || href.startsWith(prefix + '/') || href.startsWith(prefix + '#') || skip.test(href)) return;
      a.setAttribute('href', prefix + href);
    });
  }
})();
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* Announcement height -> --el-announce-h, so the nav can pin directly beneath it
     (AG1 pins announcement + nav together; measured offset there is 34px). */
  const syncAnnounceHeight = () => {
    const ann = $('.el-announce');
    const px = ann ? Math.round(ann.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--el-announce-h', px + 'px');
  };
  syncAnnounceHeight();
  window.addEventListener('resize', syncAnnounceHeight, { passive: true });
  window.addEventListener('load', syncAnnounceHeight);

  /* Header: mobile menu + scrolled shadow */
  $$('[data-el-header]').forEach((header) => {
    const toggle = $('[data-el-menu-toggle]', header);
    toggle && toggle.addEventListener('click', () => {
      const open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? (window.ellipsI18n || {}).closeMenu || 'Close menu' : (window.ellipsI18n || {}).openMenu || 'Open menu');
    });
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });

  /* Sliders / carousels (hero, quote rails): scroll-snap track + arrows + dots */
  $$('[data-el-slider]').forEach((root) => {
    const track = $('[data-el-track]', root);
    if (!track) return;
    const slides = Array.from(track.children);
    const dots = $$('[data-el-dot]', root);
    let index = 0;
    const step = () => (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth);
    const setDots = () => dots.forEach((d, k) => d.setAttribute('aria-current', String(k === index)));
    /* A rail arrow that never disables makes the first click look broken. Loop sliders keep
       both live; plain rails reflect where the track actually is. */
    const looping = () => root.dataset.elLoop === 'true';
    const setArrows = () => {
      const p = $('[data-el-prev]', root); const n = $('[data-el-next]', root);
      if (!p && !n) return;
      if (looping()) { [p, n].forEach((b) => b && b.removeAttribute('aria-disabled')); return; }
      const maxScroll = track.scrollWidth - track.clientWidth - 2;
      const atStart = track.scrollLeft <= 2;
      const atEnd = track.scrollLeft >= maxScroll;
      if (p) p.setAttribute('aria-disabled', String(atStart));
      if (n) n.setAttribute('aria-disabled', String(atEnd));
    };
    const go = (n) => {
      index = Math.max(0, Math.min(slides.length - 1, n));
      if (root.dataset.elLoop === 'true') index = (n + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setDots();
      setTimeout(setArrows, 400);
    };
    const prev = $('[data-el-prev]', root); const next = $('[data-el-next]', root);
    prev && prev.addEventListener('click', () => go(index - 1));
    next && next.addEventListener('click', () => go(index + 1));
    dots.forEach((d, k) => d.addEventListener('click', () => go(k)));
    /* Autoplay, opt-in per section. Pauses on hover, focus, tab-hidden and for users who
       ask for reduced motion, and stops for good once someone interacts. */
    const autoplaySecs = Number(root.dataset.elAutoplay || 0);
    if (autoplaySecs > 0 && slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let timer = 0; let stopped = false;
      const tick = () => { if (!stopped && !document.hidden) go(index + 1 >= slides.length ? 0 : index + 1); };
      const start = () => { if (!stopped && !timer) timer = setInterval(tick, autoplaySecs * 1000); };
      const pause = () => { if (timer) { clearInterval(timer); timer = 0; } };
      const stop = () => { stopped = true; pause(); };
      root.addEventListener('mouseenter', pause);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', pause);
      document.addEventListener('visibilitychange', () => (document.hidden ? pause() : start()));
      [prev, next, ...dots].forEach((el) => el && el.addEventListener('click', stop));
      track.addEventListener('touchstart', stop, { passive: true });
      start();
    }

    setArrows();
    window.addEventListener('resize', setArrows, { passive: true });
    track.addEventListener('scroll', setArrows, { passive: true });

    let raf = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const k = Math.round(track.scrollLeft / step());
        if (k !== index && k >= 0 && k < slides.length) { index = k; setDots(); }
      });
    }, { passive: true });
  });

  /* Accordions (footer menus, quality list) */
  $$('[data-el-accordion]').forEach((item) => {
    const btn = $('[data-el-accordion-toggle]', item);
    btn && btn.addEventListener('click', () => {
      const open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  /* Tabs */
  $$('[data-el-tabs]').forEach((root) => {
    const tabs = $$('[data-el-tab]', root); const panels = $$('[data-el-panel]', root);
    const activate = (i) => {
      tabs.forEach((t, k) => { t.classList.toggle('is-active', k === i); t.setAttribute('aria-selected', String(k === i)); });
      panels.forEach((p, k) => { p.hidden = k !== i; });
    };
    tabs.forEach((t, i) => t.addEventListener('click', () => activate(i)));
    activate(0);
  });

  /* Expandable cards (ingredients) */
  $$('[data-el-expand]').forEach((card) => {
    const btn = $('[data-el-expand-toggle]', card);
    btn && btn.addEventListener('click', () => {
      const open = card.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  /* Buy box: variant + selling plan selection, price display, gallery */
  $$('[data-el-buy]').forEach((root) => {
    const data = $('[data-el-product-json]', root);
    if (!data) return;
    const product = JSON.parse(data.textContent);
    const variantInput = $('[data-el-variant-id]', root);
    const planInput = $('[data-el-selling-plan]', root);
    const priceEl = $('[data-el-price]', root); const compareEl = $('[data-el-compare]', root);
    const totalEl = $('[data-el-total]', root); const totalCompareEl = $('[data-el-total-compare]', root);
    const perDayEl = $('[data-el-per-day]', root); const ctaPrice = $('[data-el-cta-price]', root);
    const kitValue = Number(root.dataset.elKitValue || 0);
    const days = Number(root.dataset.elDays || 90);
    const fmt = window.ellipsFormatMoney;
    const state = { variant: product.variants.find((v) => String(v.id) === String(variantInput && variantInput.value)) || product.variants[0], plan: planInput ? planInput.value : '' };
    const render = () => {
      const v = state.variant;
      const alloc = state.plan ? (v.selling_plan_allocations || []).find((a) => String(a.selling_plan_id) === String(state.plan)) : null;
      const price = alloc ? alloc.price : v.price;
      const compare = alloc ? (alloc.compare_at_price || v.compare_at_price) : v.compare_at_price;
      if (priceEl) priceEl.textContent = fmt(price);
      if (compareEl) { compareEl.textContent = compare && compare > price ? fmt(compare) : ''; compareEl.hidden = !(compare && compare > price); }
      if (totalEl) totalEl.textContent = fmt(price);
      if (totalCompareEl) totalCompareEl.textContent = fmt((compare || price) + kitValue);
      if (perDayEl) perDayEl.textContent = ((window.ellipsI18n || {}).perDay || '[price] a day').replace('[price]', fmt(Math.round(price / days)));
      if (ctaPrice) ctaPrice.textContent = fmt(price);
      if (planInput) planInput.disabled = !state.plan;
      if (variantInput) variantInput.value = v.id;
      if (planInput) planInput.value = state.plan;
      $$('[data-el-formula]', root).forEach((b) => b.classList.toggle('is-selected', String(b.dataset.elFormula) === String(v.id)));
      $$('[data-el-plan]', root).forEach((b) => b.classList.toggle('is-selected', String(b.dataset.elPlan) === String(state.plan)));
      $$('[data-el-formula-name]', root).forEach((n) => { n.textContent = v.title; });
    };
    $$('[data-el-formula]', root).forEach((b) => b.addEventListener('click', () => {
      state.variant = product.variants.find((v) => String(v.id) === String(b.dataset.elFormula)) || state.variant; render();
    }));
    $$('[data-el-plan]', root).forEach((b) => b.addEventListener('click', () => { state.plan = b.dataset.elPlan; render(); }));
    /* gallery */
    const main = $$('[data-el-gallery-img]', root); const thumbs = $$('[data-el-gallery-thumb]', root);
    thumbs.forEach((t, i) => t.addEventListener('click', () => {
      main.forEach((m, k) => m.classList.toggle('is-active', k === i));
      thumbs.forEach((x, k) => x.classList.toggle('is-active', k === i));
    }));
    /* straight to checkout: add the selected variant (+ optional kit items) then redirect */
    const form = $('form[data-el-checkout]', root);
    form && form.addEventListener('submit', (e) => {
      if (!window.fetch) return; // native fallback: /cart/add with return_to=/checkout
      e.preventDefault();
      const btn = $('[data-el-cta]', root); btn && btn.classList.add('is-loading');
      const items = [{ id: Number(state.variant.id), quantity: 1 }];
      if (state.plan) items[0].selling_plan = Number(state.plan);
      const kit = $('[data-el-kit-ids]', root);
      if (kit && kit.value) kit.value.split(',').filter(Boolean).forEach((id) => items.push({ id: Number(id), quantity: 1 }));
      const gf = $('[data-el-gift-ids]', root);
      if (state.plan && gf && gf.value) {
        gf.value.split(',').map((x) => x.trim()).filter(Boolean).forEach((id) => items.push({ id: Number(id), quantity: 1 }));
      }
      const hj = { 'Content-Type': 'application/json', Accept: 'application/json' };
      fetch(window.ellipsUrl('cart/clear.js'), { method: 'POST', headers: hj })
        .then(() => fetch(window.ellipsUrl('cart/add.js'), { method: 'POST', headers: hj, body: JSON.stringify({ items }) }))
        .then((r) => { if (!r.ok) throw new Error('add failed'); window.location.href = window.ellipsUrl('checkout'); })
        .catch(() => { btn && btn.classList.remove('is-loading'); form.submit(); });
    });
    render();
  });

  /* On the page the link already points at, turn the sticky bar into an in-page jump to the
     buy box rather than a full reload of the page the shopper is standing on. */
  $$('[data-el-sticky] a[href], .el-band a[href]').forEach((a) => {
    let url;
    try { url = new URL(a.getAttribute('href'), window.location.origin); } catch (e) { return; }
    if (url.pathname !== window.location.pathname || url.hash) return;
    const target = document.getElementById('buy') || $('[data-el-pdp-form]');
    if (!target) return;
    a.setAttribute('href', '#buy');
    a.addEventListener('click', (e) => {
      e.preventDefault();
      (document.getElementById('buy') || target).scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* Sticky offer bar: show after N px, hide while the buy box / band / footer is on screen */
  $$('[data-el-sticky]').forEach((bar) => {
    const after = Number(bar.dataset.elStickyAfter || 600);
    const targets = $$(bar.dataset.elStickyHide || '#buy');
    let blocked = 0;
    const update = () => { const on = window.scrollY > after && blocked === 0; bar.classList.toggle('is-visible', on); bar.setAttribute('aria-hidden', String(!on)); };
    if ('IntersectionObserver' in window && targets.length) {
      const seen = new Map();
      const io = new IntersectionObserver((entries) => { entries.forEach((en) => seen.set(en.target, en.isIntersecting)); blocked = [...seen.values()].filter(Boolean).length; update(); }, { rootMargin: '0px 0px -10% 0px' });
      targets.forEach((t) => io.observe(t));
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  });
})();

/* ---- Product buy box (AG1-shaped): formula + pack + subscribe/one-time ---- */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  $$('[data-el-pdp]').forEach((root) => {
    const dataEl = $('[data-el-pdp-json]', root);
    const cfgEl = $('[data-el-pdp-config]', root);
    if (!dataEl || !cfgEl) return;
    let product, cfg;
    try { product = JSON.parse(dataEl.textContent); cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    const fmt = window.ellipsFormatMoney;
    const fmt3 = window.ellipsFormatMoney;
    const fi = Number(cfg.formulaOption); // index into variant.options, -1 when absent
    const pi = Number(cfg.packOption);
    const capsSingle = Number(root.dataset.elCapsulesSingle || 50);
    const capsDouble = Number(root.dataset.elCapsulesDouble || 100);
    /* Stacked layout: the delivery rhythm is a choice of its own, and each slot maps every variant to
       one selling plan id (resolved in Liquid from the section settings). */
    const stacked = cfg.layout === 'stacked';
    const planMap = cfg.planMap || {};

    const packValues = [];
    product.variants.forEach((v) => {
      const p = pi >= 0 ? v.options[pi] : '';
      if (packValues.indexOf(p) === -1) packValues.push(p);
    });

    /* Seed from the variant the server actually rendered (deep links carry ?variant=),
       otherwise a link to the 2-jar pack silently flips back to the 1-jar on load. */
    const idInput = $('[data-el-variant-id]', root);
    const seeded = (idInput && product.variants.find((v) => String(v.id) === String(idInput.value))) || product.variants[0];
    const state = {
      formula: fi >= 0 ? seeded.options[fi] : '',
      pack: pi >= 0 ? seeded.options[pi] : '',
      mode: 'sub',
      cadence: Number(cfg.cadenceDefault) || 0,
    };

    const findVariant = () => product.variants.find((v) =>
      (fi < 0 || v.options[fi] === state.formula) && (pi < 0 || v.options[pi] === state.pack)) || product.variants[0];

    /* Both delivery frequencies are exposed on both variants now, so choose by the frequency
       this pack is meant to use rather than taking whichever happens to be first. */
    const freqFor = (packValue) => {
      const opts = cfg.packPlanOptions || [];
      const i = packValues.indexOf(packValue);
      return i >= 0 ? opts[i] : opts[0];
    };
    /* A storefront allocation carries only selling_plan_id, never the plan itself, so build a
       plan-id -> delivery-frequency map from the product's selling_plan_groups. */
    const planFreq = {};
    (product.selling_plan_groups || []).forEach((g) => {
      (g.selling_plans || []).forEach((sp) => {
        const o = (sp.options || [])[0];
        if (o) planFreq[String(sp.id)] = o.value;
      });
    });
    const planIdFor = (v, slot) => (planMap[String(v.id)] || [])[slot] || null;
    const allocById = (v, id) => (id ? (v.selling_plan_allocations || []).find((a) => String(a.selling_plan_id) === String(id)) || null : null);
    const subAlloc = (v) => {
      if (stacked) return allocById(v, planIdFor(v, state.cadence));
      const allocs = v.selling_plan_allocations || [];
      if (!allocs.length) return null;
      const want = freqFor(state.pack);
      if (want) {
        const hit = allocs.find((a) => planFreq[String(a.selling_plan_id)] === want);
        if (hit) return hit;
      }
      return allocs[0];
    };

    function render() {
      const v = findVariant();
      if (stacked && !planIdFor(v, state.cadence)) {
        const first = (planMap[String(v.id)] || []).findIndex(Boolean);
        if (first >= 0) state.cadence = first;
      }
      const alloc = subAlloc(v);
      const once = v.price;
      const sub = alloc ? alloc.price : null;
      const hasSub = sub !== null;
      if (!hasSub) state.mode = 'once';
      const shown = state.mode === 'sub' && hasSub ? sub : once;
      const isDouble = pi >= 0 && packValues.indexOf(state.pack) === 1;
      const caps = isDouble ? capsDouble : capsSingle;

      // headline price + strike + saving pill
      const priceEl = $('[data-el-price]', root);
      const wasEl = $('[data-el-was]', root);
      const pillEl = $('[data-el-savepill]', root);
      if (priceEl) priceEl.textContent = fmt(shown);
      if (wasEl) { const show = state.mode === 'sub' && hasSub; wasEl.textContent = show ? fmt(once) : ''; wasEl.hidden = !show; }
      const pct = hasSub ? Math.round((1 - sub / once) * 100) : 0;
      if (pillEl) {
        const show = state.mode === 'sub' && hasSub && pct > 0;
        pillEl.textContent = (cfg.subPillTemplate || 'Save [pct]%').replace('[pct]', pct);
        pillEl.hidden = !show;
      }
      /* Email pages: the price row stays the normal offer, and a pink bubble under it shows the price with the shopper's
         discount code taken off (checkout truncates the discount to the cent). The codes only cover the first
         subscription payment, so the bubble names the normal price that follows. */
      const codePct = Number(cfg.codePercent) || 0;
      const codeBox = $('[data-el-code]', root);
      const codeOn = Boolean(cfg.code) && codePct > 0 && Boolean(codeBox) && !codeBox.hidden;
      const codeOff = codeOn ? Math.floor(shown * codePct / 100 + 1e-9) : 0;
      if (codeOn) {
        const isSub = state.mode === 'sub' && hasSub;
        const codeNow = $('[data-el-code-now]', codeBox);
        if (codeNow) codeNow.textContent = fmt(shown - codeOff);
        const codeLine = $('[data-el-code-line]', codeBox);
        if (codeLine) codeLine.textContent = ((isSub ? cfg.codeLineSub : cfg.codeLineOnce) || '').split('[percent]').join(codePct);
        const codeThen = $('[data-el-code-then]', codeBox);
        if (codeThen) { codeThen.textContent = isSub ? (cfg.codeThen || '').split('[price]').join(fmt(sub)) : ''; codeThen.hidden = !isSub; }
      }
      const perUnit = $('[data-el-perunit]', root);
      if (perUnit) perUnit.textContent = (cfg.perUnitTemplate || '[unit] per capsule · [count] capsules')
        .replace('[unit]', fmt(shown / caps))
        .replace('[count]', caps);

      // purchase-type rows
      const subPrice = $('[data-el-sub-price]', root);
      const oncePrice = $('[data-el-once-price]', root);
      const subPill = $('[data-el-sub-pill]', root);
      const subNote = $('[data-el-sub-note]', root);
      if (subPrice) subPrice.textContent = hasSub ? fmt(sub) : '-';
      if (oncePrice) oncePrice.textContent = fmt(once);
      if (subPill) subPill.textContent = hasSub && pct > 0 ? (cfg.subPillTemplate || 'Save [pct]%').replace('[pct]', pct) : '';
      if (subNote) subNote.textContent = isDouble ? (cfg.subNoteDouble || '') : (cfg.subNoteSingle || '');
      $$('[data-el-mode]', root).forEach((b) => {
        const on = b.dataset.elMode === state.mode;
        b.classList.toggle('is-on', on); b.setAttribute('aria-checked', String(on));
        if (b.dataset.elMode === 'sub' && !stacked) b.hidden = !hasSub;
      });

      if (stacked) {
        const packIdx = Math.max(0, packValues.indexOf(state.pack));
        const subOn = state.mode === 'sub' && hasSub;
        const offer = $('[data-el-offer]', root);
        if (offer) offer.classList.toggle('is-once', !subOn);
        $$('[data-el-panel]', root).forEach((p) => {
          p.classList.toggle('is-on', p.dataset.elPanel === (subOn ? 'sub' : 'once'));
          if (p.dataset.elPanel === 'sub') p.hidden = !hasSub;
        });
        $$('[data-el-panel-body]', root).forEach((b) => { b.hidden = b.dataset.elPanelBody !== (subOn ? 'sub' : 'once'); });
        const headPill = $('[data-el-sub-headpill]', root);
        if (headPill) { headPill.textContent = (cfg.stackedPill || 'Save [pct]%').replace('[pct]', pct); headPill.hidden = !(hasSub && pct > 0); }
        const subWas = $('[data-el-sub-was]', root);
        if (subWas) { subWas.textContent = hasSub ? fmt(once) : ''; subWas.hidden = !hasSub; }
        $$('[data-el-cadence]', root).forEach((c) => {
          const i = Number(c.dataset.elCadence);
          const ok = Boolean(planIdFor(v, i));
          const on = ok && i === state.cadence;
          c.classList.toggle('is-on', on); c.setAttribute('aria-checked', String(on));
          c.disabled = !ok;
          const t = $('[data-el-cadence-text]', c);
          const label = packIdx === 1 ? c.dataset.elLabelDouble : c.dataset.elLabelSingle;
          if (t && label) t.textContent = label;
        });
        /* Each pack card prices itself for its own panel: plan price at the chosen rhythm under
           subscribe, the plain variant price under one-time. */
        $$('[data-el-pack-card]', root).forEach((card) => {
          const value = card.dataset.elPack;
          const jars = packValues.indexOf(value) + 1 || 1;
          const pv = product.variants.find((x) => (fi < 0 || x.options[fi] === state.formula) && (pi < 0 || x.options[pi] === value));
          if (!pv) return;
          const pa = card.dataset.elPackMode === 'sub' ? allocById(pv, planIdFor(pv, state.cadence)) : null;
          const now = pa ? pa.price : pv.price;
          const cardPct = pa ? Math.round((1 - pa.price / pv.price) * 100) : 0;
          const nowEl = $('[data-el-pack-now]', card);
          if (nowEl) nowEl.textContent = fmt(now);
          const wasCard = $('[data-el-pack-was]', card);
          if (wasCard) { wasCard.textContent = pa ? fmt(pv.price) : ''; wasCard.hidden = !pa; }
          const unitEl = $('[data-el-pack-unit]', card);
          if (unitEl) { unitEl.textContent = (cfg.perJar || '[price] a jar').replace('[price]', fmt(Math.round(now / jars))); unitEl.hidden = jars < 2; }
          const badge = $('[data-el-pack-badge]', card);
          if (badge) { badge.textContent = (cfg.subPillTemplate || 'Save [pct]%').replace('[pct]', cardPct); badge.hidden = !(cardPct > 0); }
        });
      }
      /* Every [data-el-sub-only] block, not just the first: the included list AND the welcome-gift
         panel both carry it, and gifts only ship with a subscription. */
      $$('[data-el-sub-only]', root).forEach((el) => { el.hidden = state.mode !== 'sub'; });

      // choices
      $$('[data-el-formula]', root).forEach((b) => {
        const on = b.dataset.elFormula === state.formula;
        b.classList.toggle('is-on', on); b.setAttribute('aria-checked', String(on));
      });
      $$('[data-el-pack]', root).forEach((b) => {
        const on = b.dataset.elPack === state.pack;
        b.classList.toggle('is-on', on); b.setAttribute('aria-checked', String(on));
      });
      $$('[data-el-formula-name]', root).forEach((n) => { n.textContent = state.formula; });

      // form + cta
      const vid = $('[data-el-variant-id]', root);
      const plan = $('[data-el-plan-id]', root);
      if (vid) vid.value = v.id;
      if (plan) {
        const use = state.mode === 'sub' && hasSub;
        plan.value = use ? alloc.selling_plan_id : '';
        plan.disabled = !use;
      }
      const ctaPrice = $('[data-el-cta-price]', root);
      if (ctaPrice) ctaPrice.textContent = '· ' + fmt(shown - codeOff);
      const cta = $('[data-el-cta]', root);
      if (cta) cta.disabled = !v.available;
    }

    root.addEventListener('click', (e) => {
      const f = e.target.closest('[data-el-formula]');
      if (f) { state.formula = f.dataset.elFormula; render(); return; }
      const c = e.target.closest('[data-el-cadence]');
      if (c) { if (!c.disabled) { state.cadence = Number(c.dataset.elCadence); render(); } return; }
      const p = e.target.closest('[data-el-pack]');
      if (p) { state.pack = p.dataset.elPack; render(); return; }
      const m = e.target.closest('[data-el-mode]');
      if (m) { state.mode = m.dataset.elMode; render(); return; }
      const t = e.target.closest('[data-el-gal-thumb]');
      if (t) {
        const thumbs = $$('[data-el-gal-thumb]', root); const imgs = $$('[data-el-gal-img]', root);
        const i = thumbs.indexOf(t);
        promoteSlide(imgs[i]);
        imgs.forEach((im, k) => im.classList.toggle('is-active', k === i));
        thumbs.forEach((x, k) => x.classList.toggle('is-active', k === i));
      }
    });

    /* Gallery slides past the first ship with their URLs in data attributes so they cost
       nothing on load. Promote one when it is about to be shown, and warm the rest once the
       shopper shows any interest in the gallery. */
    function promoteSlide(img) {
      if (!img || !img.dataset.src) return;
      if (img.dataset.srcset) { img.srcset = img.dataset.srcset; delete img.dataset.srcset; }
      img.src = img.dataset.src; delete img.dataset.src;
    }
    const gallery = $('[data-el-gal-thumb]', root) ? $('.el-pdp__media', root) : null;
    if (gallery) {
      const warm = () => {
        $$('[data-el-gal-img]', root).forEach(promoteSlide);
        gallery.removeEventListener('pointerenter', warm);
        gallery.removeEventListener('touchstart', warm);
      };
      gallery.addEventListener('pointerenter', warm, { once: true });
      gallery.addEventListener('touchstart', warm, { once: true, passive: true });
    }

    /* straight to checkout, like AG1's Buy now */
    const form = $('form[data-el-pdp-form]', root);
    form && form.addEventListener('submit', (e) => {
      if (!window.fetch) return;
      e.preventDefault();
      const cta = $('[data-el-cta]', root); cta && cta.classList.add('is-loading');
      const v = findVariant(); const alloc = subAlloc(v);
      const item = { id: Number(v.id), quantity: 1 };
      const subscribing = state.mode === 'sub' && alloc;
      if (subscribing) item.selling_plan = Number(alloc.selling_plan_id);
      /* Welcome gifts ride along with a subscription only, exactly as AG1 scopes theirs.
         A "WELCOME GIFT" automatic discount on the store zeroes them at checkout, so the
         order summary shows each one struck through at its value and then FREE. */
      const items = [item];
      const giftField = $('[data-el-gift-ids]', root);
      if (subscribing && giftField && giftField.value) {
        giftField.value.split(',').map((x) => x.trim()).filter(Boolean)
          .forEach((id) => items.push({ id: Number(id), quantity: 1 }));
      }
      const json = { 'Content-Type': 'application/json', Accept: 'application/json' };
      /* Buy now is a purchase intent, not an accumulation: start from an empty cart so a
         second click cannot silently double the order or strand a stale gift line. */
      fetch(window.ellipsUrl('cart/clear.js'), { method: 'POST', headers: json })
        .then(() => fetch(window.ellipsUrl('cart/add.js'), { method: 'POST', headers: json, body: JSON.stringify({ items }) }))
        .then((r) => { if (!r.ok) throw new Error('add failed'); window.location.href = window.ellipsUrl('checkout'); })
        .catch(() => { cta && cta.classList.remove('is-loading'); form.submit(); });
    });

    /* Email pages: the inline check under the bubble hides it when the browser's discount_code cookie is not this page's
       code. Shopify also keeps codes on the cart, so look there before settling on the normal price. */
    const codeBoxInit = $('[data-el-code]', root);
    if (codeBoxInit && codeBoxInit.hidden && cfg.code) {
      fetch(window.ellipsUrl('cart.js'), { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((cart) => {
          const want = String(cfg.code).toUpperCase();
          if ((cart.discount_codes || []).some((d) => String(d.code).toUpperCase() === want)) { codeBoxInit.hidden = false; render(); }
        })
        .catch(() => {});
    }

    render();
  });
})();

/* ---- Formula slider: jar cards that pick the formula, with that formula's photos, description and
   saving copy. The buy box above owns the formula state and every price; this block reacts to it. ---- */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  $$('[data-el-formula-slider]').forEach((wrap) => {
    const root = wrap.closest('[data-el-pdp]');
    const dataEl = root && $('[data-el-pdp-json]', root);
    const cfgEl = root && $('[data-el-pdp-config]', root);
    if (!dataEl || !cfgEl) return;
    let product, cfg;
    try { product = JSON.parse(dataEl.textContent); cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    const formulas = cfg.formulas || [];
    if (!formulas.length) return;
    const fmt = window.ellipsFormatMoney;
    const fi = Number(cfg.formulaOption);
    const pi = Number(cfg.packOption);
    const byName = {};
    formulas.forEach((f) => { byName[f.value] = f; });

    /* ---------- slider mechanics ---------- */
    const viewport = $('[data-el-formula-viewport]', wrap);
    const cards = $$('.el-formula-card', wrap);
    const prev = $('[data-el-formula-prev]', wrap);
    const next = $('[data-el-formula-next]', wrap);
    const bar = $('[data-el-formula-progress]', wrap);
    const step = () => (cards[0] ? cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(cards[0].parentNode).columnGap) || 0) : 160);
    function syncNav() {
      const max = viewport.scrollWidth - viewport.clientWidth;
      wrap.classList.toggle('is-static', max <= 2);
      if (prev) prev.disabled = viewport.scrollLeft <= 2;
      if (next) next.disabled = viewport.scrollLeft >= max - 2;
      if (bar && viewport.scrollWidth > 0) {
        const frac = Math.min(1, viewport.clientWidth / viewport.scrollWidth);
        const pos = max > 0 ? viewport.scrollLeft / max : 0;
        bar.style.width = (frac * 100).toFixed(2) + '%';
        bar.style.transform = `translateX(${(pos * (1 / frac - 1) * 100).toFixed(2)}%)`;
      }
    }
    prev && prev.addEventListener('click', () => viewport.scrollBy({ left: -step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => viewport.scrollBy({ left: step(), behavior: 'smooth' }));
    viewport.addEventListener('scroll', syncNav, { passive: true });
    window.addEventListener('resize', syncNav);

    /* A mouse can drag the row; a drag never counts as a choice. */
    let drag = null;
    viewport.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, left: viewport.scrollLeft, moved: false, id: e.pointerId };
    });
    window.addEventListener('pointermove', (e) => {
      if (!drag || e.pointerId !== drag.id) return;
      const dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) > 5) { drag.moved = true; viewport.classList.add('is-dragging'); }
      if (drag.moved) viewport.scrollLeft = drag.left - dx;
    });
    window.addEventListener('pointerup', () => {
      if (!drag) return;
      const moved = drag.moved;
      drag = null;
      if (!moved) return;
      viewport.classList.remove('is-dragging');
      viewport.dataset.elDragged = '1';
      setTimeout(() => { delete viewport.dataset.elDragged; }, 50);
    });
    viewport.addEventListener('click', (e) => {
      if (viewport.dataset.elDragged) { e.stopPropagation(); e.preventDefault(); }
    }, true);
    wrap.addEventListener('keydown', (e) => {
      const i = cards.indexOf(document.activeElement);
      if (i < 0) return;
      let j = -1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = Math.min(cards.length - 1, i + 1);
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = Math.max(0, i - 1);
      if (j < 0 || j === i) return;
      e.preventDefault();
      cards[j].focus();
      cards[j].click();
    });

    /* ---------- prices for the copy outside the buy box ---------- */
    const packValues = [];
    product.variants.forEach((v) => { const p = pi >= 0 ? v.options[pi] : ''; if (packValues.indexOf(p) === -1) packValues.push(p); });
    const idInput = $('[data-el-variant-id]', root);
    const current = () => product.variants.find((v) => idInput && String(v.id) === String(idInput.value)) || product.variants[0];
    const variantFor = (formula, pack) => product.variants.find((v) => v.options[fi] === formula && (pi < 0 || v.options[pi] === pack));
    const slot = Number(cfg.cadenceDefault) || 0;
    /* The strip, the sticky bar and the closing band quote the one-jar subscription at the default rhythm. */
    function headline(formula) {
      const v = variantFor(formula, packValues[0]);
      if (!v) return null;
      const id = ((cfg.planMap || {})[String(v.id)] || [])[slot];
      const a = (v.selling_plan_allocations || []).find((x) => String(x.selling_plan_id) === String(id));
      return a ? { pct: Math.round((1 - a.price / v.price) * 100), sub: a.price, cap: Math.round(a.price / (Number(root.dataset.elCapsulesSingle) || 50)) } : null;
    }
    function replaceIn(node, from, to) {
      if (!node) return;
      const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
      const pctRe = new RegExp('(^|\\D)' + from.pct + '([\\s\\u00a0\\u202f]?%)', 'g');
      for (let t = walker.nextNode(); t; t = walker.nextNode()) {
        let s = t.nodeValue;
        if (from.pct !== to.pct) s = s.replace(pctRe, '$1' + to.pct + '$2');
        if (from.sub !== to.sub) s = s.split(fmt(from.sub)).join(fmt(to.sub));
        if (from.cap !== to.cap) s = s.split(fmt(from.cap)).join(fmt(to.cap));
        if (s !== t.nodeValue) t.nodeValue = s;
      }
    }

    /* ---------- formula -> photos, description, copy ---------- */
    const main = $('.el-pdp__main', root);
    const slides = $$('[data-el-gal-img]', root);
    const thumbs = $$('[data-el-gal-thumb]', root);
    const blurb = $('[data-el-formula-blurb]', root);
    let shown = current().options[fi];
    let quoted = headline(shown);

    function swapFirst(img, pic) {
      const layer = document.createElement('img');
      layer.className = 'el-pdp__fade';
      layer.alt = '';
      layer.sizes = img.sizes;
      layer.srcset = pic.srcset;
      layer.src = pic.src;
      main.appendChild(layer);
      const done = () => { img.srcset = pic.srcset; img.src = pic.src; img.alt = pic.alt || ''; setTimeout(() => layer.remove(), 80); };
      const go = () => { requestAnimationFrame(() => layer.classList.add('is-in')); setTimeout(done, 420); };
      if (layer.complete && layer.naturalWidth) go(); else { layer.onload = go; layer.onerror = done; }
    }

    function apply(name) {
      const f = byName[name];
      if (!f || name === shown) return;
      shown = name;
      (f.gallery || []).forEach((pic, i) => {
        const img = slides[i];
        if (img) {
          if (img.hasAttribute('src')) {
            if (i === 0) swapFirst(img, pic);
            else { img.srcset = pic.srcset; img.src = pic.src; img.alt = pic.alt || ''; }
          } else {
            img.dataset.src = pic.src; img.dataset.srcset = pic.srcset; img.alt = pic.alt || '';
          }
        }
        const t = thumbs[i] && $('img', thumbs[i]);
        if (t) { t.srcset = pic.thumbset; t.src = pic.thumb; }
      });
      slides.forEach((im, k) => im.classList.toggle('is-active', k === 0));
      thumbs.forEach((b, k) => b.classList.toggle('is-active', k === 0));
      if (blurb && f.blurb) {
        blurb.classList.add('is-swapping');
        setTimeout(() => { blurb.textContent = f.blurb; blurb.classList.remove('is-swapping'); }, 180);
      }
      const to = headline(name);
      if (quoted && to) {
        [$('.el-pdp__strip', root)].concat($$('.el-sticky__text'), $$('.el-band')).forEach((n) => replaceIn(n, quoted, to));
        quoted = to;
      }
      const card = cards.find((c) => c.dataset.elFormula === name);
      if (card) {
        const vr = viewport.getBoundingClientRect(); const cr = card.getBoundingClientRect();
        const pad = window.innerWidth < 750 ? parseFloat(getComputedStyle(viewport).scrollPaddingLeft) || 0 : 0;
        if (cr.left < vr.left + pad) viewport.scrollBy({ left: cr.left - vr.left - pad - 2, behavior: 'smooth' });
        else if (cr.right > vr.right) viewport.scrollBy({ left: cr.right - vr.right + 2, behavior: 'smooth' });
      }
    }

    function syncDeltas() {
      const v = current();
      const pack = pi >= 0 ? v.options[pi] : '';
      const prices = formulas.map((f) => variantFor(f.value, pack)).filter(Boolean).map((x) => x.price);
      const min = prices.length ? Math.min.apply(null, prices) : 0;
      $$('.el-formula-card--premium', wrap).forEach((c) => {
        const d = $('[data-el-formula-delta]', c);
        const pv = variantFor(c.dataset.elFormula, pack);
        if (d && pv) d.textContent = pv.price > min ? '+' + fmt(pv.price - min) : '';
      });
    }

    // The buy box registered its click handler first, so the variant input is already current here.
    root.addEventListener('click', () => {
      const v = current();
      if (v && v.options[fi] !== shown) apply(v.options[fi]);
      syncDeltas();
    });

    let warmed = false;
    const warm = () => {
      if (warmed) return;
      warmed = true;
      formulas.forEach((f) => (f.gallery || []).slice(0, 1).forEach((pic) => { const i = new Image(); i.src = pic.src; }));
    };
    wrap.addEventListener('pointerenter', warm, { once: true });
    wrap.addEventListener('touchstart', warm, { once: true, passive: true });

    syncNav();
    syncDeltas();
    requestAnimationFrame(syncNav);
  });
})();
